import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import { initReactI18next } from "react-i18next";
import { de_moment_resource } from "./moment/de";
import { en_moment_resource } from "./moment/en";
import { es_moment_resource } from "./moment/es";
import { fr_moment_resource } from "./moment/fr";
import { it_moment_resource } from "./moment/it";
import { pt_moment_resource } from "./moment/pt";
import { legal_de_Translation, screens_de_Translation } from "./resources/de";
import { legal_en_Translation, screens_en_Translation } from "./resources/en";
import { legal_es_Translation, screens_es_Translation } from "./resources/es";
import { legal_fr_Translation, screens_fr_Translation } from "./resources/fr";
import { legal_it_Translation, screens_it_Translation } from "./resources/it";
import { legal_pt_Translation, screens_pt_Translation } from "./resources/pt";

const resources = {
  en: {
    translation: {
      ...legal_en_Translation,
      ...screens_en_Translation,
    },
  },
  es: {
    translation: {
      ...legal_es_Translation,
      ...screens_es_Translation,
    },
  },
  fr: {
    translation: {
      ...legal_fr_Translation,
      ...screens_fr_Translation,
    },
  },
  de: {
    translation: {
      ...legal_de_Translation,
      ...screens_de_Translation,
    },
  },
  it: {
    translation: {
      ...legal_it_Translation,
      ...screens_it_Translation,
    },
  },
  pt: {
    translation: {
      ...legal_pt_Translation,
      ...screens_pt_Translation,
    },
  },
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
    supportedLngs: ["en", "es", "fr", "de", "it", "pt"],
    // supportedLngs: ["en", "es"],
    detection: {
      order: ["navigator"],
      convertDetectedLanguage: (props) => {
        const lang = props.split("-")[0];
        const isSupported = ["en", "es", "fr", "de", "it", "pt"].includes(lang);
        // const isSupported = ["en", "es"].includes(lang);
        return isSupported ? lang : "en";
      },
    },
    resources,
  });

const customMonthNames = {
  en: en_moment_resource,
  es: es_moment_resource,
  fr: fr_moment_resource,
  de: de_moment_resource,
  it: it_moment_resource,
  pt: pt_moment_resource,
};

const setMomentLocale = () => {
  const currentLang = i18next.language;
  moment.updateLocale(currentLang, {
    months: customMonthNames[currentLang]?.months || [],
    monthsShort: customMonthNames[currentLang]?.monthsShort || [],
  });
};

i18next.on("languageChanged", setMomentLocale);

setMomentLocale();

export default i18next;
